import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDivider } from '@angular/material/list';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { RootState } from '@next/core-lib/app';
import { NotificationEmptyComponent } from '@next/core-lib/components';
import { TranslatePipe } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';

import { UserPreferenceSetting } from '../../models/preferences.model';
import * as PreferenceActions from '../../store/preferences.actions';
import * as PreferenceSelectors from '../../store/preferences.selectors';

@Component({
  selector: 'app-preferences-overview',
  templateUrl: './preferences-overview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./preferences-overview.component.scss'],
  imports: [
    MatDivider,
    MatSlideToggle,
    ReactiveFormsModule,
    FormsModule,
    NotificationEmptyComponent,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class PreferencesOverviewComponent implements OnDestroy {
  public preferenceGroups$ = this.store.select(PreferenceSelectors.getPreferenceGroups);

  constructor(private readonly store: Store<RootState>) {}

  ngOnDestroy(): void {
    this.store.dispatch(PreferenceActions.clearPreferenceGroupsRequest());
  }

  updateUserSetting(groupKey: string, subGroupKey: string, method: string, enabled: boolean) {
    const userPreferenceSetting: UserPreferenceSetting = {
      groupKey,
      subGroupKey,
      method,
      enabled,
    };

    this.store.dispatch(
      PreferenceActions.patchPreferenceRequest({ preference: userPreferenceSetting }),
    );
  }
}
